import React, { useState } from "react";
import PropTypes from "prop-types";
import * as S from "./PremiosSorteados.Style";
import {
  ButtonPrimaryTransparent,
  CardWithPagination,
  Headline,
  Modal,
  Text,
  WidgetCard,
} from "../../common";
import { applyKey } from "../../../utils";

const LIMIT_PAGE = 15;

const PremiosSorteados = (props) => {
  const { descricao, combinacoes } = props;
  const [showDrawnNumbersModal, setShowDrawnNumbersModal] = useState(false);
  const [premioCincoMensalidades, setPremioCincoMensalidades] = useState([]);

  const showModalHandle = (combinacoesCincoMensalidades) => {
    setShowDrawnNumbersModal(true);
    setPremioCincoMensalidades(combinacoesCincoMensalidades);
  };

  const listagemDeItens = (items) => {
    return applyKey(items, ({ descricao: descricaoCombinacao }) => (
      <S.ResultNumber as={Text} textSize="lg">
        {descricaoCombinacao.split("-")[0]}
      </S.ResultNumber>
    ));
  };

  return (
    <>
      <WidgetCard
        {...props}
        header={
          <Text>
            {descricao || (
              <>
                Número sorteado para o <strong>prêmio principal</strong>
              </>
            )}
          </Text>
        }
      >
        {combinacoes.length <= 10 ? (
          applyKey(combinacoes, ({ descricao: descricaoCombinacao }) => (
            <S.ResultNumber textSize="lg">{descricaoCombinacao}</S.ResultNumber>
          ))
        ) : (
          <S.DrawnNumbersButton
            as={ButtonPrimaryTransparent}
            onClick={() => showModalHandle(combinacoes)}
          >
            Ver os {combinacoes.length} números sorteados
          </S.DrawnNumbersButton>
        )}
      </WidgetCard>
      <Modal
        show={showDrawnNumbersModal}
        onToggle={setShowDrawnNumbersModal}
        headerModal={
          <Headline
            reset={{ marginBottom: "0px" }}
            text="Números sorteados para o prêmio de 5 vezes o valor da mensalidade"
            nivel="5"
          />
        }
      >
        <S.ModalBody>
          <CardWithPagination
            listaCompleta={premioCincoMensalidades}
            limitPage={LIMIT_PAGE}
            onSearchCondition={(item, search) =>
              item.descricao.startsWith(search)
            }
            listagemDeItens={listagemDeItens}
          />
        </S.ModalBody>
      </Modal>
    </>
  );
};

PremiosSorteados.propTypes = {
  descricao: PropTypes.string.isRequired,
  combinacoes: PropTypes.instanceOf(Object).isRequired,
};

export default PremiosSorteados;
